// extracted by mini-css-extract-plugin
module.exports = {"LetsTalkPage":"LetsTalk_LetsTalkPage__103vS","Content":"LetsTalk_Content__OXeZa","ButtonContainer":"LetsTalk_ButtonContainer__1CoRm","LetsTalkText":"LetsTalk_LetsTalkText__1yafd"};